module.exports = ":host .ticket-design .preview__image-container {\n  background-image: url(\"assets/img/ticket_design_text_bg.png\"); }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/ticket-design-presentation/ticket-print/ticket-print.presentation.scss
// module id = gEDu
// module chunks = 12